'use client';

import { useState } from 'react';
import Image from 'next/image';
import "@/styles/platform-tabs.css"

type Platform = 'linkedin' | 'instagram';

interface PlatformTabsProps {
  onTabChange?: (platform: Platform) => void;
  defaultTab?: Platform; // used when uncontrolled
  value?: Platform; // controlled value
}

export const PlatformTabs = ({ onTabChange, defaultTab = 'linkedin', value }: PlatformTabsProps) => {
    const [internalTab, setInternalTab] = useState<Platform>(defaultTab);
    const activeTab = value ?? internalTab;

    const handleTabClick = (platform: Platform) => {
        if (value === undefined) {
            setInternalTab(platform);
        }
        onTabChange?.(platform);
    };

    return (
        <div className="relative tab-variant-light text-gray-1000/90 text-sm/5 leading-[.28px] font-normal p-1 ">
            {/* Background styling */}
            <div className="absolute top-0 left-0 w-full h-full rounded-full pointer-events-none bg-gray-1000/5">
                <div className="absolute top-0 left-0 w-full h-full rounded-full" data-theme="morning">
                    <div className="absolute top-0 left-0 w-full h-full rounded-full tab-light-overlay-1 transition" />
                    <div className="absolute top-0 left-0 w-full h-full rounded-full tab-light-overlay-2 transition" />
                    <div className="absolute top-0 left-0 w-full h-full rounded-full tab-light-overlay-3 transition" />
                    <div className="absolute top-0 left-0 w-full h-full rounded-full tab-light-overlay-4 transition" />
                    <div className="absolute top-0 left-0 w-full h-full rounded-full tab-light-border mask-border p-px" />
                    <div className="absolute top-0 left-0 w-full h-full rounded-full tab-light-shadow" />
                </div>
            </div>
          
            {/* Tab selector */}
            <div className="relative z-10 h-8 rounded-full flex items-center">
                {/* Active tab indicator */}
                <div 
                    className={`absolute bg-gray-100/60 h-8 rounded-full transition-all duration-300 ease-in-out shadow-[inset_0_0_0_2px_rgba(255,255,255,1)] ${
                        activeTab === 'linkedin' ? 'left-0 w-[50%]' : 'left-[50%] w-[50%]'
                    }`}
                />
                
                {/* LinkedIn tab */}
                <button
                    onClick={() => handleTabClick('linkedin')}
                    className={`relative z-10  gap-2 flex-1 h-8 rounded-full flex items-center justify-center transition-colors duration-300 px-3 ${
                        activeTab === 'linkedin' 
                            ? 'text-gray-900 font-medium' 
                            : 'text-gray-500 hover:text-gray-700'
                    }`}
                >
                    <Image src="/funnel/linkedin.png" alt="" aria-hidden width={24} height={24} className={`${activeTab === 'linkedin' ? 'opacity-100' : 'opacity-50'}`} />
                    LinkedIn
                </button>
                
                {/* Instagram tab */}
                <button
                    onClick={() => handleTabClick('instagram')}
                    className={`relative z-10 gap-2 flex-1 h-8 rounded-full flex items-center justify-center transition-colors duration-300 px-3 ${
                        activeTab === 'instagram' 
                            ? 'text-gray-900 font-medium' 
                            : 'text-gray-500 hover:text-gray-700'
                    }`}
                >
                    <Image src="/funnel/instagram.png" alt="" aria-hidden width={24} height={24} className={`${activeTab === 'instagram' ? 'opacity-100' : 'opacity-50'}`} />
                    Instagram
                </button>
            </div>
        </div>
    );
};